import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  class: "d-flex align-center mt-4",
  style: {"gap":"16px"}
}

import { ref, computed, onMounted } from 'vue'
import { timeToHourMinutes } from '../../utils/utils'
import api from '../../../api/v2/api';
import { headerState } from '../../stores/header'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserTimeGoalChangeDialog',
  props: {
    update: { type: Function }
  },
  setup(__props: any) {

const props = __props

const hours = ref(0)
const minutes = ref(0)
const dialog = ref(false)

const numberRules = [(v: any) => !!v || '値入力必要']

const timeRations = [
  {
    timeRation: 180 * 60,
    timeLabel: '週3時間'
  },
  {
    timeRation: 240 * 60,
    timeLabel: '週4時間'
  },
  {
    timeRation: 300 * 60,
    timeLabel: '週5時間'
  },
  {
    timeRation: 360 * 60,
    timeLabel: '週6時間'
  },
]

const timeRation = computed({
  get: () => hours.value * 60 * 60 + minutes.value * 60,
  set: (value: number) => {
    const res = timeToHourMinutes(value)
    hours.value = res.hours
    minutes.value = res.minutes
  }
})

const schoolSetting = computed(() => headerState.schoolSetting)

onMounted(async () => {
  const user = await api.user.get()
  timeRation.value = user.learnTimeGoalValue
  if (!timeRation.value) {
    timeRation.value = timeRations[schoolSetting.value.learnTimeGoalValueSetting - 1].timeRation
  }
})

const onUpdate = async () => {
  if (props.update) {
    await props.update(timeRation.value)
  }
  dialog.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    transition: "dialog-bottom-transition",
    "max-width": "600",
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event))
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({
        class: "ms-1 me-1",
        size: "small",
        color: "indigo",
        variant: "outlined"
      }, props), {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" 変更 ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("学習時間目標設定", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_radio_group, {
                  modelValue: timeRation.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRation).value = $event)),
                  "hide-details": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeRations, (item, index) => {
                      return _createVNode(_component_v_radio, {
                        key: index,
                        label: item.timeLabel,
                        value: item.timeRation
                      }, null, 8 /* PROPS */, ["label", "value"])
                    }), 64 /* STABLE_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_text_field, {
                  modelValue: hours.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hours).value = $event)),
                  label: "時間",
                  type: "number",
                  variant: "underlined",
                  "hide-details": "",
                  min: "0",
                  max: "168",
                  class: "flex-grow-1"
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: minutes.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((minutes).value = $event)),
                  label: "分",
                  type: "number",
                  variant: "underlined",
                  "hide-details": "",
                  min: "0",
                  max: "59",
                  class: "flex-grow-1"
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, { class: "justify-end px-4 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "flat",
                color: "primary",
                onClick: onUpdate
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" 更新 ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})